import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'remunerations-military',
    templateUrl: './remunerations-military.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class RemunerationsMilitaryComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.RemunerationsMilitaryVM = {} as models.RemunerationsMilitaryVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;


  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
